module.exports = "../study/imgs/maps/Tokyo/S8/WaterEnvironment/Chlave/Tokyo_Chlave_HadGEM2_RCP85_Mid.png";